<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ea-audit-sync-actions [pages]="['LOAN']"></ea-audit-sync-actions>
    <fieldset disabled class="audit-locked">
    <div class="row">
      <div class="col-md-12">
        <pr-input-radio
          formControlName="enable"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Avez-vous au moins un prêt en cours ?"
        >
        </pr-input-radio>
      </div>
    </div>
    @if (form.get('enable').value) {
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-column
            label="Montant global des prêts"
            [derrors]="derrors"
            [suffix]="'€'"
          >
            <input formControlName="amount" type="text" placeholder="200000" />
          </pr-input-column>
        </div>
        <div class="col-md-6">
          <pr-input-column
            label="Montant mensuel des prêts"
            [derrors]="derrors"
            [suffix]="'€'"
          >
            <input
              formControlName="monthlyAmount"
              type="text"
              placeholder="200000"
            />
          </pr-input-column>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-md-12">
          <pr-input-column
            label="Montant restant à rembourser"
            [derrors]="derrors"
            [suffix]="'€'"
          >
            <input
              formControlName="remainingToPaid"
              type="text"
              placeholder="200000"
            />
          </pr-input-column>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-md-12">
          <pr-input-radio
            formControlName="mainResidence"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous un prêt pour votre résidence principale ?"
          >
          </pr-input-radio>
        </div>
      </div>
      @if (form.get('mainResidence').value) {
        <div class="row mt-1">
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts pour votre résidence principale"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="mainResidenceMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
          <div class="col-md-6">
            <pr-input-column
              label="Montant restant à rembourser pour votre résidence principale"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="mainResidenceRemainingToPaid"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        </div>
      }
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="travaux"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un prêt pour des travaux ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('travaux').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts pour des travaux"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="travauxMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="ptz"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un prêt à taux zéro ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('ptz').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts à taux zéro"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="ptzMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="car"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un prêt automobile ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('car').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts automobile"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="carMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="student"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un prêt étudiant ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('student').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts étudiant"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="studentMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="consumption"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un prêt à la consommation ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('consumption').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts à la consommation"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="consumptionMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="realEstate"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un prêt immobilier ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('realEstate').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts immobilier"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="realEstateMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="investment"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un prêt pour un investissement ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('investment').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des prêts pour des investissements"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="investmentMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
      <div class="row mt-1">
        <div class="col-md-6">
          <pr-input-radio
            formControlName="other"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Avez-vous au moins un autre prêt ?"
          >
          </pr-input-radio>
        </div>
        @if (form.get('other').value) {
          <div class="col-md-6">
            <pr-input-column
              label="Montant mensuel des autres prêts"
              [derrors]="derrors"
              [suffix]="'€'"
            >
              <input
                formControlName="otherMonthlyAmount"
                type="text"
                placeholder="200000"
              />
            </pr-input-column>
          </div>
        }
      </div>
    }
    </fieldset>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
